import Vue from 'vue';

export async function all(form, search = null, pagination = {}) {
  const { data } = await Vue.axios.get('/api/posts', {
    params: {
      ...form,
      search,
      ...pagination,
    },
  });

  return data;
}

export async function show(id) {
  const { data } = await Vue.axios.get(`/api/posts/${id}`);

  return data.data;
}

export async function apply(id, form) {
  const { data } = await Vue.axios.post(`/api/posts/${id}/apply`, form);

  return data.data;
}
